import React, { useEffect, useState } from "react";
import '../Components/Contact.css';
import SEO from "../Components/SEO";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaCheckCircle, FaUser, FaBuilding, FaMoneyBillWave } from "react-icons/fa";
import AOS from "aos";
import 'aos/dist/aos.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    projectType: "",
    location: "",
    budgetRange: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Full Name is required";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required";
    } else if (!/^\d{10}$/.test(formData.phone.trim().replace(/[-+ ]/g, ""))) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.projectType) newErrors.projectType = "Please select a project type";
    if (!formData.location.trim()) newErrors.location = "Location is required";
    if (!formData.budgetRange) newErrors.budgetRange = "Please select a budget range";
    if (!formData.message.trim()) newErrors.message = "Message is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setFormSuccess(true);
      setFormData({
        name: "",
        phone: "",
        email: "",
        projectType: "",
        location: "",
        budgetRange: "",
        message: ""
      });
      setTimeout(() => setFormSuccess(false), 5000);
    }
  };

  return (
    <div className="contact-page">
      <SEO 
        title="Contact Us" 
        description="Get in touch with VARK Builders Private Limited in Madurai. Visit our office, email us, or fill out our enquiry form to discuss your residential or commercial project."
      />

      <div className="contact-banner">
        <div className="container" data-aos="fade-up">
          <h1>Get In <span>Touch</span></h1>
          <p>Let's build your future together. Reach out to us for any inquiries or consultations.</p>
        </div>
      </div>

      <section className="contact-section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info-grid">
              <div className="info-card glassy" data-aos="fade-up">
                <FaPhoneAlt className="info-icon" />
                <h3>Call Us</h3>
                <p>+91 98429 43377</p>
                <p>098429 43377</p>
              </div>
              <div className="info-card glassy" data-aos="fade-up" data-aos-delay="100">
                <FaEnvelope className="info-icon" />
                <h3>Email Us</h3>
                <p>varkbuilders@gmail.com</p>
                <p>support@varkbuilders.com</p>
              </div>
              <div className="info-card glassy" data-aos="fade-up" data-aos-delay="200">
                <FaMapMarkerAlt className="info-icon" />
                <h3>Visit Us</h3>
                <p>20, 1st Floor, Annai Teresa street,</p>
                <p>Bypass Rd, Fathima Nagar, Madurai - 625016</p>
              </div>
              <div className="info-card glassy" data-aos="fade-up" data-aos-delay="300">
                <FaClock className="info-icon" />
                <h3>Work Hours</h3>
                <p>Mon - Sat: 9 AM - 9 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>

            <div className="contact-split">
              <div className="contact-form-wrap glassy" data-aos="fade-right">
                <h2>Request a <span>Consultation</span></h2>
                {formSuccess ? (
                  <div className="form-success-message-contact">
                    <FaCheckCircle className="success-icon" />
                    <h3>Consultation Request Submitted!</h3>
                    <p>Thank you for choosing VARK Builders. Our engineering representative will call you shortly.</p>
                  </div>
                ) : (
                  <form onSubmit={handleFormSubmit} className="contact-form-elements" noValidate>
                    <div className="form-input-group-contact">
                      <label htmlFor="name"><FaUser /> Full Name</label>
                      <input 
                        type="text" 
                        id="name" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleInputChange} 
                        placeholder="John Doe"
                        className={errors.name ? "error-input-contact" : ""}
                      />
                      {errors.name && <span className="error-text-contact">{errors.name}</span>}
                    </div>

                    <div className="form-input-group-contact">
                      <label htmlFor="phone"><FaPhoneAlt /> Phone Number</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        name="phone" 
                        value={formData.phone} 
                        onChange={handleInputChange} 
                        placeholder="98429 43377"
                        className={errors.phone ? "error-input-contact" : ""}
                      />
                      {errors.phone && <span className="error-text-contact">{errors.phone}</span>}
                    </div>

                    <div className="form-input-group-contact">
                      <label htmlFor="email"><FaEnvelope /> Email Address</label>
                      <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        value={formData.email} 
                        onChange={handleInputChange} 
                        placeholder="name@example.com"
                        className={errors.email ? "error-input-contact" : ""}
                      />
                      {errors.email && <span className="error-text-contact">{errors.email}</span>}
                    </div>

                    <div className="form-input-group-contact">
                      <label htmlFor="projectType"><FaBuilding /> Project Type</label>
                      <select 
                        id="projectType" 
                        name="projectType" 
                        value={formData.projectType} 
                        onChange={handleInputChange}
                        className={errors.projectType ? "error-input-contact" : ""}
                      >
                        <option value="">Select Project Type</option>
                        <option value="Residential">Residential Construction</option>
                        <option value="Commercial">Commercial Construction</option>
                        <option value="Renovation">Renovation & Remodeling</option>
                        <option value="Interior">Interior Works</option>
                        <option value="Turnkey">Turnkey Construction</option>
                        <option value="Architecture">Architecture & Planning</option>
                      </select>
                      {errors.projectType && <span className="error-text-contact">{errors.projectType}</span>}
                    </div>

                    <div className="form-input-group-contact">
                      <label htmlFor="location"><FaMapMarkerAlt /> Project Location</label>
                      <input 
                        type="text" 
                        id="location" 
                        name="location" 
                        value={formData.location} 
                        onChange={handleInputChange} 
                        placeholder="e.g. Madurai, Bypass Road"
                        className={errors.location ? "error-input-contact" : ""}
                      />
                      {errors.location && <span className="error-text-contact">{errors.location}</span>}
                    </div>

                    <div className="form-input-group-contact">
                      <label htmlFor="budgetRange"><FaMoneyBillWave /> Budget Range</label>
                      <select 
                        id="budgetRange" 
                        name="budgetRange" 
                        value={formData.budgetRange} 
                        onChange={handleInputChange}
                        className={errors.budgetRange ? "error-input-contact" : ""}
                      >
                        <option value="">Select Estimated Budget</option>
                        <option value="<15 Lakhs">Below ₹15 Lakhs</option>
                        <option value="15-30 Lakhs">₹15 Lakhs - ₹30 Lakhs</option>
                        <option value="30-60 Lakhs">₹30 Lakhs - ₹60 Lakhs</option>
                        <option value="60 Lakhs - 1.5 Crore">₹60 Lakhs - ₹1.5 Crore</option>
                        <option value=">1.5 Crore">Above ₹1.5 Crore</option>
                      </select>
                      {errors.budgetRange && <span className="error-text-contact">{errors.budgetRange}</span>}
                    </div>

                    <div className="form-input-group-contact full-width-contact">
                      <label htmlFor="message">Project Requirements / Message</label>
                      <textarea 
                        id="message" 
                        name="message" 
                        value={formData.message} 
                        onChange={handleInputChange} 
                        placeholder="Tell us about your architectural design or construction plans..." 
                        rows="4"
                        className={errors.message ? "error-input-contact" : ""}
                      ></textarea>
                      {errors.message && <span className="error-text-contact">{errors.message}</span>}
                    </div>

                    <button type="submit" className="submit-btn font-oswald">Request Consultation</button>
                  </form>
                )}
              </div>

              <div className="map-wrap glassy" data-aos="fade-left">
                <iframe
                  title="Vark Builders Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.1476483582455!2d78.094595!3d9.92154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00cf3e7869695d%3A0xc6081da268579ad!2sVark%20Builders!5e0!3m2!1sen!2sin!4v1711531234567"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
